import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'

export const domainSchema = z.object({ domainId: idSchema('domain') })
